import React, { useState, useContext } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
// Removed image upload imports
import { useNavigate } from "react-router-dom";
import "./BlogAdd.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import { BlogContext } from "../context/BlogContext";

function BlogAdd() {
    const { addBlogToState } = useContext(BlogContext);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    // Removed imageFile state
    const [imageUrl, setImageUrl] = useState("");
    // Removed error and success state, using SweetAlert instead
    const [uploading, setUploading] = useState(false);
    const navigate = useNavigate();

    // Removed handleImageUpload function

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUploading(true);
        let finalImageUrl = imageUrl;
        try {
            const docRef = await addDoc(collection(db, "blogs"), {
                title,
                content,
                imageUrl: finalImageUrl,
                date: serverTimestamp()
            });

            const newBlog = {
                id: docRef.id,
                title,
                content,
                imageUrl: finalImageUrl,
                date: { seconds: Math.floor(Date.now() / 1000) } // Use a client-side date for the UI
            };

            addBlogToState(newBlog);
            setTitle("");
            setContent("");
            setImageUrl("");
            Swal.fire({
                icon: "success",
                title: "Blog added successfully!",
                showConfirmButton: false,
                timer: 1200
            }).then(() => navigate("/blog"));
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Failed to add blog",
                text: err.message
            });
        }
        setUploading(false);
    };

    return (
        <div className="blog-add-container">
            <h2>Add New Blog</h2>
            <form onSubmit={handleSubmit}>
                <input type="text" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} required />
                <div style={{ marginBottom: "40px" }}>
                    <ReactQuill
                        value={content}
                        onChange={setContent}
                        style={{ height: "200px", marginBottom: 16 }}
                    />
                </div>
                {/* Image upload removed */}
                <div style={{ marginBottom: 12 }}>
                    <label>Image URL :  </label>
                    <input type="url" placeholder="https://example.com/image.jpg" value={imageUrl} onChange={e => setImageUrl(e.target.value)} />
                </div>
                <button type="submit" className="button" disabled={uploading}>{uploading ? "Adding..." : "Add Blog"}</button>
            </form>
            {/* SweetAlert handles feedback */}
        </div>
    );
}

export default BlogAdd;
